import Components from './components'
import Views from './views'
import Common from './common'

export default {
  Components,
  Views,
  Common
}
